import { render, staticRenderFns } from "./mutiselectElement.vue?vue&type=template&id=2caeca22&scoped=true"
import script from "./mutiselectElement.vue?vue&type=script&lang=js"
export * from "./mutiselectElement.vue?vue&type=script&lang=js"
import style0 from "./mutiselectElement.vue?vue&type=style&index=0&id=2caeca22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caeca22",
  null
  
)

export default component.exports